import Service from './service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default abstract class Query<Result = void, Param = any> extends Service<Result, Param> {
  readonly = true
}
